import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  background: ${theme.palette.primary.maxContrast.concat('04')}; // with opacity

  padding-top: ${size[60]};
  padding-bottom: ${size[60]};

  ${breakpoint.up('md')} {
    padding-top: ${size[64]};
    padding-bottom: ${size[60]};
  }
`
export const itemsContainer = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${size[40]};
  padding: 0;
  list-style: none;
  margin: ${size[40]} 0 0;

  ${breakpoint.up('md')} {
    display: grid;
    grid-template-columns: repeat(2, minmax(auto, 510px));
    justify-content: space-between;
    margin-top: ${size[90]};
  }
`
export const itemHeadline = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  line-height: 222%;
  font-weight: 700;

  ${breakpoint.up('md')} {
    line-height: 182%;
  }
`

export const item = css`
  display: flex;
  flex-direction: column;
  color: #2a272e;
`
